export const flowSteps = [
  {
    id: 1,
    step: "01",
    title: "process.flow.step1.title",
    desc: "process.flow.step1.desc",
  },
  {
    id: 2,
    step: "02",
    title: "process.flow.step2.title",
    desc: "process.flow.step2.desc",
  },
  {
    id: 3,
    step: "03",
    title: "process.flow.step3.title",
    desc: "process.flow.step3.desc",
  },
  {
    id: 4,
    step: "04",
    title: "process.flow.step4.title",
    desc: "process.flow.step4.desc",
  },
  {
    id: 5,
    step: "05",
    title: "process.flow.step5.title",
    desc: "process.flow.step5.desc",
  },
  {
    id: 6,
    step: "06",
    title: "process.flow.step6.title",
    desc: "process.flow.step6.desc",
  },
];

export const timelineItems = [
  {
    id: 1,
    phaseKey: "process.timeline.phase1",
    timeKey: "process.timeline.time1",
  },
  {
    id: 2,
    phaseKey: "process.timeline.phase2",
    timeKey: "process.timeline.time2",
  },
  {
    id: 3,
    phaseKey: "process.timeline.phase3",
    timeKey: "process.timeline.time3",
  },
  {
    id: 4,
    phaseKey: "process.timeline.phase4",
    timeKey: "process.timeline.time4",
  },
  {
    id: 5,
    phaseKey: "process.timeline.phase5",
    timeKey: "process.timeline.time5",
  },
  {
    id: 6,
    phaseKey: "process.timeline.phase6",
    timeKey: "process.timeline.time6",
  },
];

export const pricingCards = [
  {
    id: 1,
    titleKey: "process.pricing.card1.title",
    descKey: "process.pricing.card1.desc",
  },
  {
    id: 2,
    titleKey: "process.pricing.card2.title",
    descKey: "process.pricing.card2.desc",
  },
  {
    id: 3,
    titleKey: "process.pricing.card3.title",
    descKey: "process.pricing.card3.desc",
  },
];

export const faqItems = [
  {
    id: 1,
    questionKey: "process.faq.q1",
    answerKey: "process.faq.a1",
  },
  {
    id: 2,
    questionKey: "process.faq.q2",
    answerKey: "process.faq.a2",
  },
  {
    id: 3,
    questionKey: "process.faq.q3",
    answerKey: "process.faq.a3",
  },
  {
    id: 4,
    questionKey: "process.faq.q4",
    answerKey: "process.faq.a4",
  },
  {
    id: 5,
    questionKey: "process.faq.q5",
    answerKey: "process.faq.a5",
  },
  {
    id: 6,
    questionKey: "process.faq.q6",
    answerKey: "process.faq.a6",
  },
];